var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row no-gutters statistics" }, [
    _c(
      "div",
      {
        staticClass:
          "col-md-auto col-12 d-flex flex-row justify-content-between unique-opens",
      },
      [
        _c("div", { staticClass: "unique-opens-title" }, [
          _c("b", { staticClass: "h4" }, [
            _vm._v(
              _vm._s(_vm.$t("drip-campaigns.stages.editEmails.uniqueOpens"))
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "unique-opens-values" }, [
          _c("div", [
            _c("b", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.uniqueOpens))]),
          ]),
          _vm._v(" "),
          _c("div", {}, [
            _c("small", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("drip-campaigns.stages.editEmails.openRate")) +
                  ":\n          " +
                  _vm._s(_vm.openRate)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("small", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("drip-campaigns.stages.editEmails.totalOpens")
                  ) +
                  ":\n          " +
                  _vm._s(_vm.totalOpens)
              ),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "col-md col-12 sent d-flex flex-row justify-content-center align-items-center",
      },
      [
        _c("p", [
          _c("span", { staticClass: "h4 mr-2" }, [
            _vm._v(_vm._s(_vm.$tc("global.words.sent", 1))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.sent))]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "col-md col-12 delivered d-flex flex-row justify-content-center align-items-center",
      },
      [
        _c("p", [
          _c("span", { staticClass: "h4 mr-2" }, [
            _vm._v(_vm._s(_vm.$t("global.words.delivered"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.delivered))]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "col-md col-12 d-flex flex-row justify-content-center align-items-center text-capitalize",
      },
      [
        _c("p", [
          _c("span", { staticClass: "h4 mr-2" }, [
            _vm._v(_vm._s(_vm.$tc("global.words.click", 2))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.clicks))]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }